// Carrier → Service lists shared by every screen that picks them —
// Customer, Quote, Sales Order, shipment and the portal (issue #281). The
// Carrier list is every Carrier that has a Service set up, with No Carrier
// (backend services/noCarrier.js) last; a blank Carrier means not chosen
// yet. The Service list is the chosen Carrier's Services, then every No
// Carrier Service (e.g. Customer Pickup) whatever the Carrier, so picking
// one is a single step — carrierForService then moves the Carrier to No
// Carrier. A Service with no Carrier at all shows only with no Carrier.
// Inactive entries stay listed only while already selected. Mirrors the
// backend's services/shippingCarriageService.js rule.
//
// `services` are Shipping Service rows carrying `supplier` ({ id, name,
// system_key }) or `carrier` (the portal's shape) plus `is_active`.

export const NO_CARRIER_KEY = 'no_carrier';

const carrierOf = (service) => service.supplier || service.carrier || null;
const isNoCarrier = (carrier) => carrier?.system_key === NO_CARRIER_KEY;
const shown = (service, serviceId) => service.is_active !== false || String(service.id) === String(serviceId || '');

export function carrierChoices(services, carrierId) {
  const carriers = [];
  (services || []).forEach((service) => {
    const carrier = carrierOf(service);
    if (!carrier) return;
    if (service.is_active === false && String(carrier.id) !== String(carrierId || '')) return;
    if (!carriers.some((c) => c.id === carrier.id)) carriers.push(carrier);
  });
  return carriers.sort((a, b) => (isNoCarrier(a) - isNoCarrier(b)) || a.name.localeCompare(b.name));
}

export function servicesForCarrier(services, carrierId, serviceId) {
  const all = (services || []).filter((service) => shown(service, serviceId));
  const own = all.filter((service) => String(carrierOf(service)?.id || '') === String(carrierId || ''));
  const noCarrier = all.filter((service) => isNoCarrier(carrierOf(service)) && !own.includes(service));
  return [...own, ...noCarrier];
}

// The Carrier to hold once a Service is picked: the Service's own Carrier
// (which moves it to No Carrier for a No Carrier Service), or the current
// Carrier when the Service is cleared.
export function carrierForService(services, serviceId, carrierId) {
  const service = (services || []).find((s) => String(s.id) === String(serviceId || ''));
  const carrier = service && carrierOf(service);
  return carrier ? String(carrier.id) : (carrierId || '');
}
